import { Get } from "../http/httpVerbs";

export const apiGetDesafiosStats = async (comunidadeId) => {
    try {
        let url = `${process.env.REACT_APP_API_URL}/desafios/stats?comunidade=${comunidadeId}`;
        
        const response = await Get(url);
        return response;
    } catch (error) {
        console.error("API apiGetDesafiosStats ERROR:", error);
        throw error;
    }
};
